import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { AppContext } from '../../context/AppContext';
import Card from '../common/Card';
import { FaReceipt } from 'react-icons/fa';
import UpsellComponent from '../upsellComponent';
import { getBoughtItems } from '../../api/vehicleAPI';

const SummaryCard = styled(Card)`
  padding: 30px;
  height: fit-content;
  position: sticky;
  top: 120px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    position: static;
  }
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  color: ${({ theme }) => theme.colors.primaryDark};
  margin-bottom: 25px;
`;

const OrderItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  font-size: 16px;

  span:first-child {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray};
  }

  span:last-child {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.dark};
  }
`;

const OrderTotal = styled(OrderItem)`
  font-size: 18px;
  font-weight: 700;
  border-top: 2px solid ${({ theme }) => theme.colors.primaryLight};
  margin-top: 20px;
  border-bottom: none;

  span {
    color: ${({ theme }) => theme.colors.dark};
    font-weight: 800;
  }

  span:last-child {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

const OrderSummary = ({ upsellOptions, orderId }) => {
  const { cart, addToCart } = useContext(AppContext);
  const [itensComprados, setItensComprados] = useState([]);

  console.log("Itens comprados:", itensComprados);
  console.log("Upsell :", cart);
  useEffect(() => {
    const fetchBoughtItems = async () => {
      if (orderId) {
        try {
          const data = await getBoughtItems(orderId);
          setItensComprados(data.map(item => item.id));
        } catch (error) {
          console.error("Erro ao buscar itens comprados:", error);
        }
      }
    };

    fetchBoughtItems();
  }, [orderId]);

  const hasConsultaCompleta = cart.some(item => item.id === 'CONSULTA_COMPLETA');
const hasBoughtConsultaCompleta = itensComprados.includes('CONSULTA_COMPLETA');

const basePrice = !orderId && !hasConsultaCompleta && !hasBoughtConsultaCompleta ? 14.90 : 0;
console.log("Base Price:", basePrice);
useEffect(() => {
  if (!orderId && basePrice > 0 && !hasConsultaCompleta && !hasBoughtConsultaCompleta) {
    const consultaCompleta = upsellOptions.find(opt => opt.ID === 'CONSULTA_COMPLETA');
    if (consultaCompleta) {
      addToCart({
        id: consultaCompleta.ID,
        title: consultaCompleta.title || 'Consulta Completa',
        price: Number(consultaCompleta.preco_venda) || 0
      });
    }
  }
}, [orderId, upsellOptions, addToCart, basePrice, hasConsultaCompleta, hasBoughtConsultaCompleta]);


  const blockedIds = ['CONSULTA_DEMO', 'CONSULTA_COMPLETA'];
  const availableUpsells = upsellOptions.filter(
    opt => !blockedIds.includes(opt.ID) && !itensComprados.includes(opt.ID)
  );

const cartItems = cart.filter(
  item => !(item.id === 'CONSULTA_COMPLETA' && (basePrice > 0 || hasBoughtConsultaCompleta))
);
  const totalCartPrice = cartItems.reduce((total, item) => total + (Number(item.price) || 0), 0);
  const finalTotal = basePrice + totalCartPrice;

  return (
    <SummaryCard>
      <Title><FaReceipt /> Resumo do Pedido</Title>

      {basePrice > 0 && (
        <OrderItem key="base_consulta_completa">
          <span>Consulta Completa</span>
          <span>R$ 14,90</span>
        </OrderItem>
      )}

      {cartItems.map(item => (
        <OrderItem key={item.id}>
          <span>{item.title}</span>
          <span>+ R$ {Number(item.price).toFixed(2).replace('.', ',')}</span>
        </OrderItem>
      ))}

      <OrderTotal>
        <span>Total</span>
        <span>R$ {finalTotal.toFixed(2).replace('.', ',')}</span>
      </OrderTotal>

      <UpsellComponent
        title="Informações Adicionais"
        data={availableUpsells}
      />
    </SummaryCard>
  );
};

export default OrderSummary;
